import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { MenuCategoryResponse, MenuItem, MenuItemCreate, MenuItemUpdate, MenuResponse } from '../types/api.types'

export const menuService = {
  // Always include_unavailable — this is the management view, and an item
  // hidden for the night still has to be visible to whoever hid it.
  async get(propertyId: number): Promise<MenuResponse> {
    const url = `${API_ENDPOINTS.MENU}?property_id=${propertyId}&include_unavailable=true`
    const { data } = await axiosInstance.get<MenuResponse>(url)
    return { ...data, items: data.items ?? [] }
  },

  async create(item: MenuItemCreate): Promise<MenuItem> {
    const { data } = await axiosInstance.post<MenuItem>(API_ENDPOINTS.MENU, item)
    return data
  },

  // PATCH, not PUT — send only what changed. An explicit null clears a field.
  async update(id: number, item: MenuItemUpdate): Promise<MenuItem> {
    const { data } = await axiosInstance.patch<MenuItem>(API_ENDPOINTS.MENU_ITEM_BY_ID(id), item)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.MENU_ITEM_BY_ID(id))
  },

  async renameCategory(propertyId: number, name: string, newName: string): Promise<MenuCategoryResponse> {
    const { data } = await axiosInstance.patch<MenuCategoryResponse>(API_ENDPOINTS.MENU_CATEGORIES, {
      property_id: propertyId,
      name,
      new_name: newName,
    })
    return data
  },

  // property_id/name are query params, not path segments — real category
  // names carry spaces, ampersands and parens that would break a path.
  async deleteCategory(propertyId: number, name: string): Promise<MenuCategoryResponse> {
    const url = `${API_ENDPOINTS.MENU_CATEGORIES}?property_id=${propertyId}&name=${encodeURIComponent(name)}`
    const { data } = await axiosInstance.delete<MenuCategoryResponse>(url)
    return data
  },
}
